export const logEvent = ({ action, params }) => {
  // Check for dataLayer (GTM) first, then fallback to gtag (GA4 direct)
  if (typeof window?.dataLayer !== 'undefined') {
    window.dataLayer.push({
      event: action,
      ...params,
    });
  } else if (typeof window?.gtag === 'function') {
    window.gtag('event', action, params);
  }
};

// AI Card Customization Analytics
export const logAiCardCustomization = ({ cardId, customizationType, additionalParams = {} }) => {
  logEvent({
    action: 'ai_card_customize',
    params: {
      card_id: cardId,
      customization_type: customizationType,
      ...additionalParams,
    },
  });
};

// Credits Purchase Analytics
export const logCreditsPurchase = ({ amount, purchaseId, additionalParams = {} }) => {
  logEvent({
    action: 'credits_purchase',
    params: {
      amount,
      purchase_id: purchaseId,
      ...additionalParams,
    },
  });
};
